<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar
        title="添加桌台"
        left-text="返回"
        @click-left="onClickLeft"
        left-arrow
        fixed
    />
    <!--导航栏 end-->
    <!--内容部分 start-->
    <van-form ref="forms" style="margin-top: 1.5rem">
      <van-field
          v-model="name"
          label="桌台前缀"
          required
          clearable
          placeholder="例如：包间;大厅;卡座"
          :rules="[{ required: true, message: '桌台前缀不能为空' }]"
      />
      <van-field
          v-model="num"
          label="添加数量"
          required
          clearable
          placeholder="请输入生成数量"
          type="number"
          :rules="[{ required: true, message: '桌台前缀不能为空' }]"
      />
    </van-form>
    <div style="margin: 16px;">
      <van-button @click="onSubmit" round block type="info" native-type="submit">
        确定
      </van-button>
    </div>

    <!--内容部分 end-->


  </div>
</template>

<script>
// import VueCookie from 'vue-cookies'
import {Notify, Toast} from 'vant';
export default {
  name: "SeatAdd",
  data() {
    return {
      imageList: [],
      name: '',
      num:'',
    };
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5';
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = '';
    next();
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push("/SeatList");
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      this.$refs.forms.validate().then(() => {
        var toast = Toast.loading({
          duration: 0,
          message: '添加中',
          forbidClick: true,
          loadingType: 'spinner',
        });
        this.$http.post('/wechat/api.store_class/SeatAdd', {
          name: this.name,
          num:this.num,
          // openid: window.localStorage.getItem("openid")
        }).then(response => {
          toast.clear();
          if (response && response.data.code== 200) {
            this.$router.push("/SeatList");
          }else{
            Notify({type: 'danger', message: response.data.msg});
          }
        })
      }).catch(() => {
        this.$toast.fail('必填项未填写')
      })
    },
  },
}
</script>

<style >
.van-icon-goods-collect-o::before{
  position: relative;
  top: 0.1rem;
}
.van-icon-contact::before{
  position: relative;
  top: 0.1rem;
}

.van-field >>>.van-field__label{
  width: 30px;
}
</style>
